export const getGpsRouteSegments = (points) => {
  const segments = [];
  let segment = [];

  points.forEach((point, index) => {
    const previousState = points[index - 1]?.gpsEnabledAfter;
    const currentState = point.gpsEnabledAfter;
    const isGpsGap =
      (previousState === false && currentState === true) ||
      (previousState === true && currentState === false);

    if (isGpsGap) {
      if (segment.length > 1) segments.push({ coordinates: segment, isGpsGap: false });
      segments.push({
        coordinates: [segment[segment.length - 1], [point.lat, point.lng]],
        isGpsGap: true,
      });
      segment = [];
    }

    segment.push([point.lat, point.lng]);
  });

  if (segment.length > 1) segments.push({ coordinates: segment, isGpsGap: false });
  return segments;
};
